/* eslint-disable */

import moment from 'moment'

import { Tag } from '@/types/tag'

interface MapTag {
  [name: string]: Tag
}

export default {
  name: 'HomePageComponent',
  template: '<div></div>',
  data() {
    return {
      company: 'Gaman Lab',
      settings: {
        timeFormat: 'HH:mm:ss',
        dateFormat: 'DD MMMM YYYY',
      },
      internal: {
        timeString: '',
        dateString: '',
      },
      timers: {
        cyclic1s: undefined,
      },
    }
  },
  computed: {
    tags(): MapTag {
      const self: any = this
      const tags: MapTag = {}
      for (const uid in self.$store.state.tag.items) {
        const tag: Tag = self.$store.state.tag.items[uid]
        tags[tag.name] = tag
      }

      return tags
    },
  },
  methods: {
    cyclic1s() {
      const self: any = this
      self.internal.timeString = moment().format(self.settings.timeFormat)
      self.internal.dateString = moment().format(self.settings.dateFormat)

      self.setRealtimeValue()
      self.timers.cyclic1s = setTimeout(() => {
        this.cyclic1s()
      }, 500)
    },

    goto(path: string) {
      const self: any = this
      if (self.$route.path == path) {
        return
      }
      self.$router.push(path)
    },

    setRealtimeValue() {
      const self: any = this

      for (const ref in self.$refs) {
        const tag: Tag = self.tags[ref]
        if (tag == undefined) {
          continue
        }

        const precision = self.$refs[ref].getAttribute('precision')
        if (
          precision != undefined &&
          precision != '' &&
          typeof tag.value == 'number'
        ) {
          try {
            const prec = parseInt(precision)
            self.$refs[ref].innerHTML = tag.value.toFixed(prec)
            continue
          } catch {
            //
          }
        }
        self.$refs[ref].innerHTML = tag.value
      }
    },
  },

  created() {
    const self: any = this
  },

  mounted() {
    const self: any = this
    self.cyclic1s()

    // self.setRealtimeValue()
  },

  destroyed() {
    const self: any = this
    if (self.timers.cyclic1s) {
      clearTimeout(self.timers.cyclic1s)
    }
    console.log('Destroyed')
  },
}
